import React, { useContext } from 'react';
import { IoSearchOutline, IoAddOutline } from 'react-icons/io5';
import { Button, Container } from './styles/SearchEventButton.styled';
import SearchEventContext from '../context/SearchEventContext';
import DatePickerContext from '../context/DatePickerContext';

export default function SearchEventButtons({ dir }) {
  const { displayMenu, displayFormInputs, setClear, clear, setSearchCurrValue, searchValue } =
    useContext(SearchEventContext);
  const { setCurrDateLabel, months, month, year } = useContext(DatePickerContext);

  const handleSearch = () => {
    if (searchValue) setCurrDateLabel('');
    setSearchCurrValue(searchValue);
  };

  const handleClear = () => {
    setClear(!clear);
    setSearchCurrValue('');
    setCurrDateLabel(`${months[month]} ${year}`);
  };

  return (
    <Container displayMenu={displayMenu} displayFormInputs={displayFormInputs}>
      <Button onClick={handleSearch} dir={dir}>
        <IoSearchOutline className="search" />
      </Button>
      <Button onClick={handleClear} dir={dir}>
        <IoAddOutline className="plus" />
      </Button>
    </Container>
  );
}
